import { MeetingDetailWithContext } from 'components/meetings/meeting_detail'

import { MeetingDetailProvider, MeetingDetailContext } from './meeting_detail_context'
import { MeetingDetailDependenciesProvider } from './meeting_detail_dependencies_provider'

export const MeetingDetailRightRail = ({ eventId }) => (
  <MeetingDetailDependenciesProvider>
    <MeetingDetailProvider eventId={eventId}>
      <MeetingDetailWithContext context={MeetingDetailContext} />
    </MeetingDetailProvider>
  </MeetingDetailDependenciesProvider>
)
